import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details for debugging (in development only)
    if (process.env.NODE_ENV === 'development') {
      // Only log in development - production should not have console statements
    }
    
    this.setState({
      error,
      errorInfo
    });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      // Custom fallback UI
      return (
        <div className="eb-root" style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          width: '100%',
          boxSizing: 'border-box',
          padding: '2rem',
          textAlign: 'center',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}>
          <style>{`
            @keyframes eb-fade-in {
              from { opacity: 0; transform: translateY(6px); }
              to { opacity: 1; transform: translateY(0); }
            }
            .eb-root { animation: eb-fade-in 0.35s ease-out; }
            .eb-badge {
              position: relative;
              width: 56px;
              height: 56px;
              border-radius: 50%;
              background: linear-gradient(180deg, #fef3f2 0%, #fee4e2 100%);
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 24px;
              box-shadow: 0 0 0 6px rgba(217, 45, 32, 0.05);
            }
            .eb-btn {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              padding: 10px 20px;
              border-radius: 8px;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 600;
              transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease;
            }
            .eb-btn:active { transform: translateY(1px); }
            .eb-btn-primary {
              background: linear-gradient(180deg, #4f46e5 0%, #4338ca 100%);
              color: #ffffff;
              border: none;
              box-shadow: 0 1px 2px rgba(67, 56, 202, 0.3), 0 0 0 0 rgba(67, 56, 202, 0);
            }
            .eb-btn-primary:hover { background: #3730a3; box-shadow: 0 4px 10px rgba(67, 56, 202, 0.28); }
            .eb-btn-primary:focus-visible { outline: 2px solid #a5b4fc; outline-offset: 2px; }
            .eb-btn-secondary {
              background: #ffffff;
              color: #344054;
              border: 1px solid #d0d5dd;
              box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
            }
            .eb-btn-secondary:hover { background: #f9fafb; border-color: #98a2b3; }
            .eb-btn-secondary:focus-visible { outline: 2px solid #98a2b3; outline-offset: 2px; }
          `}</style>

          <div className="eb-badge">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 9V13M12 17H12.01M10.29 3.86L1.82 18A2 2 0 0 0 3.54 21H20.46A2 2 0 0 0 22.18 18L13.71 3.86A2 2 0 0 0 10.29 3.86Z"
                stroke="#d92d20" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <h2 style={{ color: '#101828', marginBottom: '10px', fontSize: '1.25rem', fontWeight: 650, letterSpacing: '-0.01em' }}>
            Something went wrong
          </h2>
          <p style={{ color: '#667085', marginBottom: '28px', fontSize: '0.9375rem', lineHeight: 1.6, maxWidth: '380px' }}>
            An unexpected error occurred. Please try again, or refresh the page if the problem continues.
          </p>
          <div style={{ display: 'flex', gap: '12px' }}>
            <button onClick={this.handleReset} className="eb-btn eb-btn-primary">
              Try Again
            </button>
            <button onClick={() => window.location.reload()} className="eb-btn eb-btn-secondary">
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;


